import React from 'react';
import {useTranslation} from 'react-i18next';
import './index.css';
import SocialNetwork from './SocialNetwork';
import logo from '../../../assets/images/PERFECT_logo.svg';
import pathUtils from '../../../utils/pathUtils';

export default function Footer() {
  const {t, i18n} = useTranslation();

  return (
    <div className="footer">
      <a className={'footer-logo'} target={'_blank'} href={pathUtils.getPFSiteURL('/business', i18n.language)}>
        <img src={logo} style={{height: 'auto'}} alt={'perfect corp footer logo'} />
      </a>
      <div className={'footer-right'}>
        <SocialNetwork />
        <div className={'footer-copyright'}> {t('footer.copyright', '2022 © Perfect Corp. All Rights Reserved.')} </div>
      </div>
    </div>
  );
}
